import { render, staticRenderFns } from "./DataTableContainersDetails.vue?vue&type=template&id=478b78b5"
import script from "./DataTableContainersDetails.vue?vue&type=script&lang=js"
export * from "./DataTableContainersDetails.vue?vue&type=script&lang=js"
import style0 from "./DataTableContainersDetails.vue?vue&type=style&index=0&id=478b78b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports